module.exports = "<div class=\"ui-grid-cell-contents\">\n\t<div ng-if=\"grid.appScope.$ctrl.isCurrentUserAdmin()\">\n\t\t<a class=\"jf-link\"\n\t\t   ng-click=\"grid.appScope.$ctrl.onNameClick(row.entity)\">\n\t\t\t{{row.entity.permissionName}}\n\t\t</a>\n\t</div>\n\t<div ng-if=\"!grid.appScope.$ctrl.isCurrentUserAdmin()\">{{row.entity.permissionName}}</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common_templates/jf_effective_permission.name.template.html
// module id = 45
// module chunks = 0